<h2 mat-dialog-title>Share URL</h2>

<mat-dialog-content class="form-full-width">
    <form action="">
        <mat-form-field class="input-form-width">
            <input matInput placeholder="Path" disabled value="{{ data.dataUrl.replace(' ','%20') }}">
        </mat-form-field>

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16" (click)="openSnackBar()" style="cursor: pointer;" alt="Copy link">
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
      </svg>

    </form>
    <div class="form-button-row">
        <button mat-icon-button aria-label="Facebook" (click)="this.getLink('facebook')">
      <svg-icon src="assets/images/icons/facebook.svg" [svgStyle]="{ 'width.px':32, 'height': 32 }"></svg-icon>
    </button>
        <button mat-icon-button aria-label="Twitter" (click)="this.getLink('twitter')">
      <svg-icon src="assets/images/icons/twitter.svg" [svgStyle]="{ 'width.px':32, 'height': 32 }"></svg-icon>
    </button>
        <button mat-icon-button aria-label="Email" (click)="this.getLink('email')">
      <svg-icon src="assets/images/icons/email.svg" [svgStyle]="{ 'width.px':32, 'height': 32 }"></svg-icon>
    </button>
        <button mat-icon-button aria-label="Google" (click)="this.getLink('google')">
      <svg-icon src="assets/images/icons/googleplus.svg" [svgStyle]="{ 'width.px':32, 'height': 32 }"></svg-icon>
    </button>
        <button mat-icon-button aria-label="Example icon-button with a heart icon" (click)="this.getLink('whatsapp')">
      <svg-icon src="assets/images/icons/whatsapp.svg" [svgStyle]="{ 'width.px':32, 'height': 32 }"></svg-icon>
    </button>
        <button mat-icon-button aria-label="Example icon-button with a heart icon" (click)="this.getLink('twitter')">
      <svg-icon src="assets/images/icons/pinterest.svg" [svgStyle]="{ 'width.px':32, 'height': 32 }"></svg-icon>
    </button>
    </div>
</mat-dialog-content>

<mat-dialog-actions style="float: right">
    <button style="background-color: #333333; color: white;" color="warn" mat-button (click)="onNoClick()">Close</button>

</mat-dialog-actions>